import { IProductionPollState } from "../../models";
import {
  isProductionStatusActive,
  isProductionStatusFinished,
  isProductionStatusNotStarted,
  isProductionStatusTerminal,
} from "./production-status.helpers";

/**
 * Returns true if production has not been started yet.
 */
export const isProductionPollStateNotStarted = (
  state: IProductionPollState | undefined,
): boolean => {
  return isProductionStatusNotStarted(state?.status);
};

/**
 * Returns true if production is actively running.
 */
export const isProductionPollStateActive = (
  state: IProductionPollState | undefined,
): boolean => {
  return isProductionStatusActive(state?.status);
};

/**
 * Returns true if production is in a final (terminal) state.
 */
export const isProductionPollStateTerminal = (
  state: IProductionPollState | undefined,
): boolean => {
  return isProductionStatusTerminal(state?.status);
};

/**
 * Returns true if production has successfully finished.
 */
export const isProductionPollStateFinished = (
  state: IProductionPollState | undefined,
): boolean => {
  return isProductionStatusFinished(state?.status);
};
